import { reactive, computed, onBeforeMount, watch } from '@vue/composition-api'
import { formatDate } from '@/util/common'
import * as _ from 'lodash'
import Vue from 'vue'

export const InformationList = (props, context) => {
  const store = context.root.$store
  const router = context.root.$router
  const { news } = store.state

  onBeforeMount(async () => {
    action.load()
  })

  const state = reactive({
    visibleToast: false,
    visibleMenu: false, // SP用
    visibleInformationExtract: false, // SP用
    visibleWindowDetail: false, // SP用
    isListsLoaded: computed(() => store.state.news.isListsLoaded), // カルーセルロード完了フラグ
    // 表示中のカルーセルのスライド番号(SP用)
    numberCarouselVisible: computed(() => {
      return store.state.news.numberCarouselVisible
    }),
    // 表示されているカルーセルの数(SP用)
    numberCarouselLength: computed(() => {
      return data.categories.length + 1
    })
  })

  const data = reactive({
    lists: computed(() => news.lists), // store.getters['news/sortDateLists']),
    // SPページ表示用リスト
    lists_sp: computed(() => news.lists_sp),
    count: computed(() => news.pagenation.count),
    // 日付でソートされたリスト
    groupDateLists: computed(() => _.groupBy(data.lists, 'publication_day')),
    // 読み込みフラグ
    canload: computed(() => news.canload),
    filterCategories: news.search.filterCategories,
    filterClassifications: news.search.filterClassifications,
    categories: computed(() => news.categories), // お知らせカテゴリ
    classifications: computed(() => news.classifications), // お知らせ重要度
    isPaginationShown: computed(() => {
      return data.count > news.search.per_page
    })
  })

  const countLists = computed(() => {
    return store.getters['news/countLists']
  })

  // カテゴリの絞り込みを監視し、変更があればリストをリセットする
  watch(() => data.filterCategories, (newVal, oldVal) => {
    if (!oldVal) return
    if (store.state.common.device === 'sp') {
      store.dispatch('common/showToast', { text: '絞り込み条件を変更しました' })
    }
    debounceFilterCategories(newVal)
  })
  // 重要度の絞り込みを監視し、変更があればリストをリセットする
  watch(() => data.filterClassifications, (newVal, oldVal) => {
    if (!oldVal) return
    if (store.state.common.device === 'sp') {
      store.dispatch('common/showToast', { text: '絞り込み条件を変更しました' })
    }
    debounceFilterClassifications(newVal)
  })

  // カテゴリタブを押下した場合（SP用）
  const onCategorySelected = (categoryCode, numberCarouselVisible) => {
    // カルーセルロード完了フラグをfalseに設定
    store.dispatch('news/setIsListsLoaded', false)

    store.dispatch('news/setNumberCarouselVisible', numberCarouselVisible)

    let newVal = []
    if (categoryCode === 0) {
      // 全ての場合
      for (let i = 0; i < data.categories.length; i++) {
        newVal.push(data.categories[i].code)
      }
    } else {
      newVal = [categoryCode]
    }
    debounceFilterCategories(newVal)
  }

  // カテゴリ・重要度を連続押下時にAPIを連続で呼ばないように間隔をあけて実行する
  const debounceFilterCategories = _.debounce((params) => {
    store.dispatch('news/setFilterCategories', params)
  }, 500)
  const debounceFilterClassifications = _.debounce((params) => {
    store.dispatch('news/setFilterClassifications', params)
  }, 500)

  const action = {
    load: () => {
      store.dispatch('news/getLists')
      store.dispatch('news/getTypes')
    },
    routeList: (list) => {
      if (store.state.common.device === 'sp') {
        router.push({ name: 'SPInformationDetail', params: { infoId: list.id } })
      } else {
        router.push({ name: 'PCInformationDetail', params: { infoId: list.id } })
      }
    }
  }

  const clickPageNation = async ({ currentPage, start }) => {
    await store.dispatch('news/setPagenation', { currentPage, start })
    store.dispatch('news/resetLists')
    store.dispatch('news/getLists')
  }

  // SP用：カルーセル制御
  const onPageChange = (number) => {
    store.dispatch('news/setNumberCarouselVisible', number)
  }
  // SP用：カルーセル制御
  const onClickPrev = () => {
    // カルーセルロード完了フラグをfalseに設定
    store.dispatch('news/setIsListsLoaded', false)

    const number = state.numberCarouselVisible - 1 >= 0 ? state.numberCarouselVisible - 1 : 0
    store.dispatch('news/setNumberCarouselVisible', number)

    const categories = state.numberCarouselVisible === 0 ? [] : [state.numberCarouselVisible]
    debounceFilterCategories(categories)
  }
  // SP用：カルーセル制御
  const onClickNext = () => {
    // カルーセルロード完了フラグをfalseに設定
    store.dispatch('news/setIsListsLoaded', false)

    let number = state.numberCarouselVisible + 1
    if (number > state.numberCarouselLength - 1) {
      number = state.numberCarouselLength - 1
    }
    store.dispatch('news/setNumberCarouselVisible', number)

    const categories = state.numberCarouselVisible === 0 ? [] : [state.numberCarouselVisible]
    debounceFilterCategories(categories)
  }
  // SP用：カルーセル制御
  watch(() => {
    const target = document.getElementById(`navigation_${state.numberCarouselVisible}`)
    if (target) target.scrollIntoView({block: 'nearest', behavior: 'smooth'})
  })
  // SP用：カルーセルのスライドのID文字列生成
  const getSlideId = (n) => {
    if (n >= 10) {
      return 'content-' + n
    } else {
      return 'content-0' + n
    }
  }

  return {
    state,
    data,
    countLists,
    news,
    action,
    clickPageNation,
    onCategorySelected,
    formatDate,
    onPageChange, // SP用
    onClickPrev, // SP用
    onClickNext, // SP用
    getSlideId // SP用
  }
}
